function Modal({ children, isOpen, onClose }) {
  return (
    <div
      onClick={onClose}
      className={
        'fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 !m-0' +
        (isOpen ? ' block' : ' hidden')
      }
    >
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-lg w-full">
        <div
          className="size-6 relative ml-auto mb-8 overflow-hidden cursor-pointer"
          onClick={onClose}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 6L6 18M6 6L18 18"
              stroke="#050B14"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className="modal-content">{children}</div>
      </div>
    </div>
  );
}

export default Modal;
